// extracted by mini-css-extract-plugin
export default {"previewColumn":"PortalViewPreview_previewColumn__jre1k","tabs":"PortalViewPreview_tabs__AAbV7","tabPanel":"PortalViewPreview_tabPanel__-OCF6"};